export default __webpack_public_path__ + "static/chart-customisation-7cee0c1e55af1a36a6c3034d4b22cf23.png";